import { type LoaderFunctionArgs, redirect } from 'react-router';
import { getSessionReport } from '@store/helpers';

export const authGuardLoader = async ({ params }: LoaderFunctionArgs) => {
  const poNumber = params.id;

  if (!poNumber) {
    throw redirect('/login');
  }

  const storedReport = getSessionReport(poNumber);
  if (!storedReport) {
    throw redirect('/login');
  }

  return null;
};
